// AG Grid module registration (side effect) — must run before any DataGrid mounts.
import '@/components/grid/agGridModules';

import { createRoot } from 'react-dom/client';
import { addCollection } from '@iconify/react';
import * as Sentry from '@sentry/react';
import { preloadLucideIcons, registerCustomIcons } from '@utilities-one/gpm-ui';

import { App } from '@/App';

import '@/assets/css/globals.css';
import '@/assets/css/form-surfaces.css';

void preloadLucideIcons();
void registerCustomIcons();

/** The two Material Design glyphs of the structure tree and the market color picker, bundled so they render offline. */
addCollection({
  prefix: 'mdi',
  width: 24,
  height: 24,
  icons: {
    rhombus: {
      body: '<path fill="currentColor" d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2"/>',
    },
    triangle: { body: '<path fill="currentColor" d="M1 21h22L12 2"/>' },
  },
});

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    enabled: true,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element. Ensure index.html contains <div id="root"></div>');
}

createRoot(rootElement).render(<App />);
